import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { VForm } from 'vuetify/lib/components';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection2LabelForm',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  bomb: {
    type: Boolean,
    required: true,
  },
  fire: {
    type: Boolean,
    required: true,
  },
  fireCircle: {
    type: Boolean,
    required: true,
  },
  gas: {
    type: Boolean,
    required: true,
  },
  toxic: {
    type: Boolean,
    required: true,
  },
  corrosion: {
    type: Boolean,
    required: true,
  },
  exclamation: {
    type: Boolean,
    required: true,
  },
  health: {
    type: Boolean,
    required: true,
  },
  environment: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:isValid", "update:bomb", "update:fire", "update:fireCircle", "update:gas", "update:toxic", "update:corrosion", "update:exclamation", "update:health", "update:environment"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:bomb', data: boolean): void;
  (e: 'update:fire', data: boolean): void;
  (e: 'update:fireCircle', data: boolean): void;
  (e: 'update:gas', data: boolean): void;
  (e: 'update:toxic', data: boolean): void;
  (e: 'update:corrosion', data: boolean): void;
  (e: 'update:exclamation', data: boolean): void;
  (e: 'update:health', data: boolean): void;
  (e: 'update:environment', data: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const m = defineMessages({
  bombExplosion: '爆弾の爆発',
  fire: '炎',
  fireCircle: '円上の炎',
  gasCylinder: 'ガスボンベ',
  corrosive: '腐食性',
  skull: 'どくろ',
  exclamation: '感嘆符',
  healthHazard: '健康有害性',
  environment: '環境',
});



const form = ref<InstanceType<typeof VForm> | null>(null);
const isValid = ref<boolean>(false);

const aspectRatio: number = 1 / 1;
const height = 100;
const width = 100;
const opacity = (value: boolean): number => {
  return value ? 1 : 0.1;
};



const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateBomb = (e: boolean) => {
  if (props.isEditing) {
    emits('update:bomb', e);
  }
};

const updateFire = (e: boolean) => {
  if (props.isEditing) {
    emits('update:fire', e);
  }
};

const updateFireCircle = (e: boolean) => {
  if (props.isEditing) {
    emits('update:fireCircle', e);
  }
};

const updateGas = (e: boolean) => {
  if (props.isEditing) {
    emits('update:gas', e);
  }
};

const updateToxic = (e: boolean) => {
  if (props.isEditing) {
    emits('update:toxic', e);
  }
};

const updateCorrosion = (e: boolean) => {
  if (props.isEditing) {
    emits('update:corrosion', e);
  }
};

const updateExclamation = (e: boolean) => {
  if (props.isEditing) {
    emits('update:exclamation', e);
  }
};

const updateHealth = (e: boolean) => {
  if (props.isEditing) {
    emits('update:health', e);
  }
};

const updateEnvironment = (e: boolean) => {
  if (props.isEditing) {
    emits('update:environment', e);
  }
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,m, props, form, isValid, aspectRatio, height, width, opacity, emits, updateIsValid, updateBomb, updateFire, updateFireCircle, updateGas, updateToxic, updateCorrosion, updateExclamation, updateHealth, updateEnvironment, VForm }
}

})